import { render, staticRenderFns } from "./urge.vue?vue&type=template&id=d165cc58&scoped=true&"
import script from "./urge.vue?vue&type=script&lang=js&"
export * from "./urge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d165cc58",
  null
  
)

export default component.exports